import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CustodianVotesImportResultModel } from './custodian-votes-import-result-dlg.models';

@Component({
  selector: 'app-custodian-votes-import-result-dlg',
  templateUrl: './custodian-votes-import-result-dlg.component.html',
  styleUrls: ['./custodian-votes-import-result-dlg.component.scss']
})
export class CustodianVotesImportResultDlgComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: CustodianVotesImportResultModel[]) { }

  ngOnInit() {
  }

}
